import { generatePath, useNavigate } from 'react-router-dom';

import { getVmDetails } from '../../../shared/lib/general';
import { useAppStore } from '../../../shared/hooks/useAppStore';
import { useCancelOrder } from '../../order/hooks/useCancelOrder';
import { SERVICE_PAGES } from '../../service';
import { FEEDBACK_ROUTES, FEEDBACK_SRC } from '../feedback.constants';
import { useGetFeedbackData } from './useGetFeedbackData';

export const useFeedbackActions = () => {
    const navigate = useNavigate();
    const order = useAppStore((s) => s.order);
    const vm = useAppStore((s) => s.vm);
    const qrCode = useAppStore((s) => s.qrCode);
    const getFeedbackDataMutation = useGetFeedbackData();
    const { mutate: cancelOrderMutate } = useCancelOrder();

    const onFeedbackClickHandler = async () => {
        const isService = window.location.pathname.includes(SERVICE_PAGES.main);
        if (order?.id) {
            const { isCT5 } = getVmDetails(vm);
            !isCT5 && cancelOrderMutate(order.id);
        }


        // Side effects (store update, error logging) are wired at hook level
        // in useGetFeedbackData so they fire regardless of caller mount state.
        try {
            await getFeedbackDataMutation.mutateAsync({
                vmId: vm.vm_id,
                orderInfo: {
                    wallet_user_id: order.user_id,
                    transaction_id: order.id,
                    src: isService ? FEEDBACK_SRC.SERVICE : FEEDBACK_SRC.PAYMENT,
                },
            });
        } catch {
            // Already logged by the hook's onError. Navigate anyway so the user
            // isn't trapped on the previous screen.
        }

        navigate(generatePath(FEEDBACK_ROUTES.smile, { id: String(qrCode) }), {
            replace: true,
        });
    };

    return {
        onFeedbackClickHandler,
        isFeedbackLoading: getFeedbackDataMutation.isPending,
    };
};
